/* DesireMatrix product page. Vanilla only.
   The sticky buy bar lives in dm-sticky-bar.js.
   The description is no longer collapsible - it renders in full. */
(function () {
  'use strict';

  function gallery(root) {
    var slides = root.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var picks = root.querySelectorAll('[data-thumb]');
    function show(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      picks.forEach(function (b) {
        b.setAttribute('aria-current', String(Number(b.dataset.thumb) === i));
      });
    }
    picks.forEach(function (b) {
      b.addEventListener('click', function () { show(Number(b.dataset.thumb)); });
    });
  }

  function qty(form) {
    var input = form.querySelector('#dm-qty');
    if (!input) return;
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = (parseInt(input.value, 10) || 1) + Number(b.dataset.qty);
        input.value = next < 1 ? 1 : next;
      });
    });
  }

  function addToCart(form) {
    var btn = form.querySelector('[data-atc]');
    var buyBtn = form.querySelector('[data-buynow]');
    var err = form.querySelector('[data-atc-error]');
    var live = form.querySelector('[data-atc-live]');
    if (!btn) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      /* e.submitter is the actual button that triggered this submit - far
         more reliable than checking document.activeElement, which a
         programmatic .click() (as the sticky bar's proxy buttons use, or
         Safari's click-doesn't-focus behaviour) does not reliably set. */
      var isBuyNow = e.submitter && e.submitter.hasAttribute('data-buynow');

      /* ---- buy now ----
         Checks out THIS item only: empty the cart, then hand the browser a
         cart permalink that adds the one variant and forwards straight to
         checkout. Without the clear, whatever was already in the cart would
         ride along into the order, which is not what "buy now" means.

         ONE round trip, not two. This previously awaited /cart/clear.js AND
         /cart/add.js before navigating, so the customer sat through two
         sequential network calls; the permalink folds the add into the
         navigation that had to happen anyway.

         A failed clear must never block checkout - hence the same handler on
         both settle paths. */
      if (isBuyNow) {
        if (!buyBtn || buyBtn.dataset.state === 'loading') return;
        buyBtn.dataset.state = 'loading';
        buyBtn.disabled = true;
        buyBtn.textContent = 'One moment…';
        if (err) { err.hidden = true; err.textContent = ''; }

        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('#dm-qty');
        var q = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
        var go = function () {
          window.location.assign('/cart/' + Number(idField.value) + ':' + q + '?return_to=%2Fcheckout');
        };
        fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(go, go);
        return;
      }

      if (btn.dataset.state === 'loading') return;

      btn.dataset.state = 'loading';
      btn.disabled = true;
      btn.innerHTML = '<span class="dm-atc__spin"></span>Adding…';
      if (err) { err.hidden = true; err.textContent = ''; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart.');
          btn.dataset.state = 'success';
          btn.disabled = false;
          btn.textContent = '✓ Added';
          if (live) live.textContent = 'Added to cart.';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            btn.dataset.state = 'idle';
            btn.textContent = 'Add to Cart';
          }, 900);
        })
        .catch(function (ex) {
          btn.dataset.state = 'idle';
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
          if (err) { err.textContent = ex.message; err.hidden = false; }
          if (live) live.textContent = ex.message;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-gallery]').forEach(gallery);
    document.querySelectorAll('[data-atc-form]').forEach(function (f) { qty(f); addToCart(f); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
